// External packages
import { ClassNameValue, twMerge } from 'tailwind-merge';
import * as ReactAria from 'react-aria-components';
import * as React from 'react';

// Components
import { Icon } from 'components/Icons';

export const Checkbox: React.FC<
  React.ComponentProps<'label'> &
    ReactAria.CheckboxProps & {
      checkboxClassName?: ClassNameValue;
      iconClassName?: ClassNameValue;
    }
> = ({ className, checkboxClassName, iconClassName, children, ...props }) => (
  <ReactAria.Checkbox
    {...props}
    className={twMerge(
      'group inline-flex cursor-pointer items-center gap-2 data-disabled:cursor-not-allowed data-disabled:opacity-40',
      className
    )}
  >
    <div
      className={twMerge(
        'flex h-5 w-5 shrink-0 items-center justify-center rounded-sm border border-gray-300 transition-colors duration-150 group-data-selected:border-blue-600 group-data-selected:bg-blue-600',
        checkboxClassName
      )}
    >
      <Icon
        name="check"
        className={twMerge(
          'h-4 w-4 text-white opacity-0 transition-opacity duration-150 group-data-selected:opacity-100',
          iconClassName
        )}
      />
    </div>
    {children}
  </ReactAria.Checkbox>
);
